@use "../../sass/global/global.scss" as *;

ux-iws-nb-technical-data-download-button {
    display: inline-block;
}

.ux-iws-nb-technical-data-download-button {
    display: inline-block;
    box-sizing: border-box;
    align-items: center;
    background-color: $color-blue-6;
    text-decoration: none;
    padding: 16px 76px 16px 16px;
    color: #000;
    font-size: 13px;
    transition: all 0.3s ease-in-out;
    position: relative;
    min-width: 340px;
}

.ux-iws-nb-technical-data-download-button:hover,
.ux-iws-nb-technical-data-download-button:focus-visible {
    background-color: $color-blue-headline;
    color: #fff;

    .ux-iws-nb-technical-data-download-button__info {
        color: #fff;
    }
}

.ux-iws-nb-technical-data-download-button__label {
    @include font(bold);
    text-transform: uppercase;
    display: block;
}

.ux-iws-nb-technical-data-download-button__info {
    transition: all 0.3s ease-in-out;
    color: $color-gray-text;
    margin-top: 5px;
}

.ux-iws-nb-technical-data-download-button__icon {
    position: absolute;
    right: 16px;
    top: 16px;
    border: solid 1px currentColor;
    padding: 10px;

    ux-icon {
        display: block;
        font-size: 21px;
    }
}
